<template>
    <div class="relative min-h-screen min-w-screen flex flex-col justify-between pb-8">
        <div class="pb-32">
            <router-link 
              :to="{ name: 'register'}"
              class="absolute top-10 left-8"
            >
              <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mt-1.5"><path d="M1 8L17 8M8 1L1 8L8 15" stroke="#223672" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </router-link>
            <default-header 
                type="dark"
                :title="$t('thankyou')"
                :text="$t('thankyouforregister')"
                headerClasses="pb-0"
                :masked="false"
            />
            <img src="@/assets/images/sms.png" alt="" class="w-full max-w-xs mx-auto py-10 px-8">
        </div>
        <div class="flex flex-col space-y-5 px-6 fixed left-0 bottom-6 w-full">
            <default-button
              v-if="!codeReissued"
              :disabled="codeReissuePending"
              @click="resendSMSCode()"
              buttonClasses=""
              :text="$t('nosms')"
            />
            <default-button
              v-else
              @click="getHelp()"
              buttonClasses=""
              :text="$t('stillhaventreceived')"
            />
        </div>
    </div>
</template>

<script>
import DefaultHeader from "@/components/Header.vue";
import DefaultButton from "@/components/Button.vue";

export default {
  components: {
    DefaultHeader,
    DefaultButton
  },
  data() {
    return {
      codeReissued: false,
      codeReissuePending: false
    };
  },
  methods: {
    resendSMSCode() {
      this.ac = this.$route.query.ac;
      this.oid = this.$route.query.oid;

      this.axios
        .post(`${process.env.VUE_APP_API_BASE_URL}/api/app/Booking/ResendSMS?ac=${this.ac}&oid=${this.oid}`)
        .then(() => {
          this.codeReissuePending = true;
          alert('Code resent to your device.');
          setTimeout(() => {
            this.codeReissuePending = false
            this.codeReissued = true
            }, 2000);
        }).catch(() => { 
          alert('CORS error, failed to register.');
        })
    }
  }
};
</script>

<style lang="scss">

</style>